import { useTheme } from "@emotion/react";
import styled from "@emotion/styled";
import { Box, useMediaQuery } from "@mui/material";
import { setIsSidebarOpen } from "src/shared/lib/store/slices/app";
import { IconComponent } from "src/shared/components";
import { useTypedDispatch, useTypedSelector } from "src/shared/lib/store/store";
import { EIconNames } from "src/shared/types/iconNames";
import { DropdownMenu } from "./DropdownMenu";
import { HeaderButton } from "./HeaderButton";
import { Notifications } from "./Notifications";
import { Sms } from "./Sms";
import { WorkTime } from "./WorkTime";

const Header = styled("header")(({ theme }) => ({
  marginLeft: "20px",
  transition: "margin-left .2s ease-in-out",
  zIndex: 1,
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  boxShadow: "0 2px 6px hsla(0, 0%, 72%, .32)",
  height: 60,
  padding: theme.spacing(1.5, 6),
  [theme.breakpoints.down("lg")]: {
    marginLeft: 0,
  },
  [theme.breakpoints.down("md")]: {
    height: 50,
  },
}));

const Burger = styled("button")(
  ({ theme }) => `
    position: relative;
    display: none;
    margin-right: 16px;
    padding: 0;
    background: transparent;
    outline: none;
    border: none;
    color: #C4C4C4;
    cursor: pointer;
    
    ${theme.breakpoints.down("lg")} {
      display: block
    }
  `,
);

export const PageHeader = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const dispatch = useTypedDispatch();
  const isOpen = useTypedSelector((store) => store.app.isSidebarOpen);

  const toggleSidebar = () => {
    dispatch(setIsSidebarOpen(!isOpen));
  };

  return (
    <Header>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
        }}
      >
        <Burger
          id="burger"
          className={isMobile ? "visible" : undefined}
          onClick={toggleSidebar}
        >
          <IconComponent iconname={EIconNames.BURGER_OLD} fontSize="22px" />
        </Burger>
        <HeaderButton disableRipple variant="text">
          <IconComponent iconname={EIconNames.PHONE_OLD} fontSize="22px" />
          {!isMobile && "Телефонный справочник"}
        </HeaderButton>
      </Box>
      <Box
        sx={{
          display: "flex",
          gap: "8px 28px",
          alignItems: "center",
        }}
      >
        <Sms isMobile={isMobile} />
        <WorkTime isMobile={isMobile} />
        <Notifications />
        <DropdownMenu />
      </Box>
    </Header>
  );
};
